<template>
  <section>
    <div v-show="!isLoading">
      <div class="title">學習進度</div>
      <div class="progressBox" style="overflow-x:auto">
        <div class="rowTitle">
          <div style="flex:1;">任務名稱</div>
          <div style="flex:1">任務簡介</div>
          <div style="flex:1">任務類型</div>
          <div style="flex:1">任務進度</div>
          <div style="flex:1">任務期限</div>
          <div style="flex:1">動作</div>
        </div>
        <div style="max-height: 400px; overflow-y: auto">
        <div v-for="activity in displayActivity" :key="activity.id" class="rowContent">
          <div style="flex:1">{{ activity.name }}</div>
          <div style="flex:1">{{ activity.description }}</div>
          <div style="flex:1">{{ getTypeName(activity.type) }}</div>
          <div style="flex:1">{{ activity.isDone?'完成':'未完成' }}</div>
          <div style="flex:1">{{ activity.endDatetime }}</div>
          <div style="flex:1">
            <div v-if="activity.type === 'uReply'">
              <router-link :to="{name: 'ClassActivity', query: activity.query}" v-if="!activity.isDone">開始任務</router-link>
              <router-link :to="{name: 'ClassActivity', query: activity.query}" v-else-if="!activity.isFinished">更改答案</router-link>
              <span v-else style="color: gray; cursor: not-allowed;">已完結</span>
            </div>
            <div v-else>
              <router-link :to="{name: 'ClassActivity', query: activity.query}" v-if="!activity.isDone">開始任務</router-link>
              <router-link :to="{name: 'ClassActivity', query: activity.query}" v-else>重溫</router-link>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    <Loading v-show="isLoading"></Loading>
  </section>
</template>
<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
  primary: #397f1f, // The primary color of your application));
));

.title{
  margin: 3rem 0rem;
  font-size: 1.5rem;
  font-weight: 600;
  color: #397f1f;
}

.rowTitle{
  display: flex;
  background-color: #e2e2e2;
  margin: 1rem;
  font-weight: 600;
  padding: 1.5rem 1rem;
}

.rowContent{
  display: flex;
  flex: 1;
  justify-content: space-between;
  background-color: #efefef;
  padding: 0.5rem 1rem;
  margin: 1rem;
}

.progressBox{
  background-color: #f5f5f5;
  padding: 0.5rem;
  font-size: 1.1rem;
  border-radius: 1rem;
}
</style>
<script>
import Loading from '@/components/Utility/Loading.vue'
var moment = require('moment')
let format = 'YYYY-MM-DD HH:mm:ss'
export default {
  components: {
    Loading
  },
  data () {
    return {
      isLoading: true,
      userId: this.$parent.userId,
      courseId: this.$parent.courseId,
      courseActivity: null,
      weekInfo: null,
      displayActivity: [],
      ops: {
        vuescroll: {},
        scrollPanel: {},
        rail: { keepShow: true },
        bar: {
          background: '#387E1E',
          opacity: 1,
          keepShow: true
        }
      }
    }
  },
  methods: {
    getTypeName: function (type) {
      if (type === 'Reading') {
        return '其他'
      } else if (type === 'Video') {
        return '影片'
      } else if (type === 'uReply') {
        return 'uReply練習'
      }
    }
  },
  mounted: async function () {
    try {
      await this.$store.dispatch('request', {
        route: `courses/${this.courseId}/activities`
      }).then(res => {
        this.displayActivity = res.map(act => {
          act.isFinished = new Date(act.endDatetime) < new Date()
          return act
        })
      })
      this.displayActivity.sort((a, b) => {
        return moment(a.endDatetime, format).isBefore(moment(b.endDatetime, format)) ? 1 : -1
      })
      console.log(this.displayActivity.map(a => a.endDatetime))
      // await this.$store.dispatch('request', {
      //   route: `courses/${this.courseId}/report`
      // }).then(res => {
      //   this.courseActivity = res.activities
      //   this.weekInfo = res.weeks
      //   this.weekInfo.forEach((week, weekKey) => {
      //     week.activities.forEach((activity, activityKey) => {
      //       this.allWeekActivity.forEach((target) => {
      //         if (target.id === activity.id) {
      //           this.weekInfo[weekKey].activities[activityKey] = target
      //           this.displayActivity.push(target)
      //         }
      //       })
      //     })
      //   })
      //   console.log(this.displayActivity)
      // })
    } catch (err) {
      console.log(err)
      alert('更新失敗')
    }
    this.isLoading = false
  }
}
</script>
